<template>
    <Search v-if="!isDesktop"/>
    <div class="desktop-search page" v-else>
        <div class="search-results" @mouseover="onSectionsHover" @mouseleave="unlockHistorySwipe">
            <div v-for="(r, i) in results" :key="i" class="result-group" v-show="r.results.length > 0">
                <div class="result-header">
                    <h2 v-if="r.title">{{ r.title }}</h2>
                    <router-link :to="r.link" v-ripple class="see-all" v-if="r.link">
                        see all
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                            <path d="M8 21H20.4C20.7314 21 21 20.7314 21 20.4V3.6C21 3.26863 20.7314 3 20.4 3H3.6C3.26863 3 3 3.26863 3 3.6V16" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M10 6L18 6" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M6 6H7" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M3.5 20.5L12 12M12 12V16M12 12H8" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </router-link>
                </div>

                <div class="content-row" :class="r.type">
                    <template v-for="(k, j) in r.results">
                        <div class="content-row-epg-wrapper" v-if="r.type === 'epg'"  :key="j">
                            <ListGuide :guide="k"   v-ripple/>
                        </div>

                        <MediaGroup v-if="r.type === 'people'" :media="k" :key="j" />
                        <Channel v-if="r.type === 'channel'" :channel="k" :key="j" v-ripple />
                        <Game v-if="r.type === 'games'" :game="k"  :key="j" v-ripple />
                        <Sport v-if="r.type === 'sport'" :sport="k" mode="notlive" :key="j" v-ripple />
                        <Movie v-if="r.type === 'vod'" :media="k" :display="true" :list="true" :key="j"  :existingSaves="saves" />

                    </template>
                </div>
            </div>
        </div>

        <div v-if="loading" class="search-loading">
            <Loader />
        </div>
    </div>
</template>

<script>
const Search = () => import("@/views/Search.vue");
const ListGuide = () => import('@/components/ListGuide')
const Game = () => import('@/components/Game')
const Channel = () => import('@/components/Channel')
const Sport = () => import('@/components/Sport')
const MediaGroup = () => import('@/components/MediaGroup')
const Movie = () => import('@/components/desktop/Movie')
const Loader = () => import('@/components/Loader')

const ORDER = ['people', 'vod', 'games', 'sport', 'channel', 'epg'];
export default {
    name: 'DesktopSearch',

    components: {
        Search,
        Channel,
        ListGuide,
        Game,
        Sport,
        MediaGroup,
        Movie,
        Loader,
    },

    data() {
        return {
            query: '',
            results: [],
            saves: [],
            loading: true,
        }
    },

    methods: {
        onSectionsHover(e){
            const overRow = !!(e.target.closest && e.target.closest('.content-row'))
            if (overRow === !!this._historySwipeLocked) return
            overRow ? this.lockHistorySwipe() : this.unlockHistorySwipe()
        },

        lockHistorySwipe(){
            this._historySwipeLocked = true
            document.documentElement.style.overscrollBehaviorX = 'none'
            document.body.style.overscrollBehaviorX = 'none'
        },

        unlockHistorySwipe(){
            if (!this._historySwipeLocked) return
            this._historySwipeLocked = false
            document.documentElement.style.overscrollBehaviorX = ''
            document.body.style.overscrollBehaviorX = ''
        },

        debounce(func, timeout = 300) {
            let timer
            return (...args) => {
                clearTimeout(timer)
                timer = setTimeout(() => { func.apply(this, args) }, timeout)
            }
        },

        searching(query) {
            this.query = query
            this.debounce(this._searching, 500)()
        },

        _searching() {
            this.getSearchResults()
        },

        getSearchResults: async function () {
            this.loading = true
            this.results = []
            const data = await window.afetch(`/search?query=${this.query}`)
            const results = await data.json()
            this.results = results.results.sort((a, b) => {
                return ORDER.indexOf(a.type) - ORDER.indexOf(b.type);
            });
            this.loading = false
        },
        async loadSaves(){
            const saved  = await window.afetch(`/save?group=od`)
            const savedRes =  await saved.json()
            this.saves = savedRes.saves
        }
    },

    mounted() {
        document.title = 'Search The Library - QB'
        this.query = window.shuffle('ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(''))[0]
        this.getSearchResults()
        this.query = ''
        this.$root.$on('desktopSearch', (data) => {this.searching(data)})
        this.loadSaves()

    },

    beforeDestroy() {
        this.$root.$off('desktopSearch')
    },

    activated() {
        document.title = 'Search The Library - QB'
    },
}
</script>

<style lang="scss" scoped>
.desktop-search {
    padding: 24px 0;
    padding-top: 80px;
}

h2{
    font-size: 20px;
    padding-bottom: 0;
    margin: 0;
    padding-left: 48px;
}
.content-row{
    padding-left: 48px;
}
.result-group {
    margin-bottom: 12px;
    padding: 0;
}

.content-row.epg{
    flex-direction: column;
    width: 100%;
    overflow: visible;
    padding: 0;

    .content-row-epg-wrapper{
      padding: 0 48px;
      margin: 5px 0;
      display: flex;
      flex-grow: 1;
      overflow-x: scroll;
    }
  }

.result-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    width: calc(100% - 60px);

    h3 {
        margin: 0;
        font-size: 18px;
        font-weight: 600;
    }

    .see-all {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.6);
        text-decoration: none;

        &:hover {
            color: white;
        }

        svg {
            width: 12px;
            height: 12px;
        }
    }
}

.result-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 12px;

    &.epg {
        grid-template-columns: 1fr;
    }

    &.sport {
        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    }

    &.vod {
        grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    }
}

.search-loading {
    display: flex;
    justify-content: center;
    padding: 60px 0;
}
</style>
